import { render, staticRenderFns } from "./PatentIndexing.vue?vue&type=template&id=c4e27988"
import script from "./PatentIndexing.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatentIndexing.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports